import { Environment } from 'relay-runtime'
import store from './store.client.js'
import network from './network.client.js'

export default new Environment({
  network,
  store,
})
